"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var TextFieldValidator_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/field/TextFieldValidator"));
var react_1 = __importStar(require("react"));
var constants_1 = __importDefault(require("../../../../config/constants"));
var AccessibleDisabledButton_1 = __importDefault(require("../../../../shared/components/button/AccessibleDisabledButton"));
var styles_1 = __importDefault(require("../styles"));
var UpdateEmailForm = function (_a) {
    var oldEmail = _a.oldEmail, validationSchema = _a.validationSchema, onSubmit = _a.onSubmit;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var _b = (0, react_1.useState)(false), valid = _b[0], setValid = _b[1];
    var _c = (0, react_1.useState)(''), email = _c[0], setEmail = _c[1];
    var labelProps = {
        useAlternateTextField: true,
        isRequiredLabel: true,
        labelStyle: __assign(__assign({}, theme.typography.body2), { padding: theme.spacing(0, 2), gap: '2px' })
    };
    var handleEmailChange = function (event) {
        setEmail(event.target.value);
    };
    var handleBlur = function () {
        var isValid = validationSchema.isValidSync(email) && oldEmail !== email;
        setValid(isValid);
    };
    return (react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, direction: "column" },
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(core_1.Typography, { variant: "body2", style: { marginRight: theme.spacing(3), marginBottom: theme.spacing(2) } }, "Your email address is used to Sign-in to your account. Once email is changed, use your new email to sign in to your account and to receive email notifications and updates from us.")),
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(core_1.Typography, { variant: "body2" }, "Current Email"),
            react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, oldEmail)),
        react_1.default.createElement(core_1.Grid, { item: true },
            (labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) && (react_1.default.createElement(core_1.Typography, { style: labelProps.labelStyle }, "E-mail",
                labelProps.isRequiredLabel ? ' *' : '')),
            react_1.default.createElement(TextFieldValidator_1.default, { variant: constants_1.default.FIELDS_VARIANT, id: "newEmail", role: "textbox", label: !(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) ? 'New Email' : null, "aria-label": "New Email", className: classes.field, value: email, onChange: handleEmailChange, onBlur: handleBlur, validationSchema: validationSchema, inputProps: {
                    autoComplete: 'on'
                } })),
        react_1.default.createElement(core_1.Grid, { item: true, style: { display: 'flex', justifyContent: 'center' } },
            react_1.default.createElement(AccessibleDisabledButton_1.default, { size: "large", variant: "contained", color: "primary", "aria-label": "Submit", onClick: onSubmit(email), disabled: !valid }, "Submit"))));
};
exports.default = UpdateEmailForm;
//# sourceMappingURL=UpdateEmailForm.js.map